import { mapState } from 'vuex';

/**
 * @mixin mixin/index
 * @desc 공통 mixin
 * @vue-computed {String} device - 'pc' | 'mo'
 * @vue-computed {String} i18n - 현재 i18n path
 * @vue-computed {String} defaultLocale - 기본 locale
 * @vue-computed {String} rootPath - 국문이면 '', 영문이면 /en
 * @vue-computed {String} resources - resources 경로
 * @vue-computed {String} locale - 현재 언어
 */
export default {
  computed: {
    // pc
    device() {
      return process.env.VUE_APP_DEVICE;
    },
    // company-p_company005[path]
    i18n() {
      return (path) => {
        const regex = new RegExp(
          '^(' + process.env.VUE_APP_I18N_SUPPORTED_LOCALE + ')-'
        );

        return this.$route.name.replace(regex, '') + '.' + path;
      };
    },
    // ko
    defaultLocale() {
      return process.env.VUE_APP_I18N_FALLBACK_LOCALE;
    },
    // 국문이면 '', 영문이면 /en
    rootPath() {
      return this.locale === this.defaultLocale
        ? ''
        : process.env.BASE_URL + this.locale;
    },
    // ~/pc/resources
    resources() {
      return process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_RESOURCES
        : process.env.VUE_APP_RESOURCES_LOCAL;
    },
    // ko // 현재 언어
    ...mapState('view', {
      locale: 'locale'
    })
  }
};
